<div [id]="'Field:' + model.Id + ':PreviousValue'">
    Previous: {{ getPreviousValue() }}
    <aurora-link-button 
        [attr.id]="'Field:' + model.Id + ':RevertToPreviousValue'"
        class="ms-1"
        aria-label="Revert to previous value"
        (click)="revertToPreviousValue.emit()">
        <svg  class="icon-undo">
            <use xlink:href="#icon-undo"></use>
        </svg>
    </aurora-link-button>
</div>